import React from 'react'

// import useApiKeys from './useApiKeys'
import moment from 'moment'

import styled from 'styled-components'
import TypographySecondary from 'components/Typography/Secondary'

import IconButton from 'share-ui/components/IconButton/IconButton'

// import { useModal } from 'hooks'
import { StyledDeleteIcon, StyledEditIcon } from 'styles/styledIcons.css'

type CellProps = {
    value: any
}

export const DateRenderer: React.FC<CellProps> = ({ value }) => {
    // Destructure value from CellProps
    let content = null

    if (value === null) {
        const currentTime = moment().fromNow()
        content = <TypographySecondary value={currentTime} size={'small'} />
    } else {
        const formattedDate = moment(value).fromNow() // Use the destructured value
        content = <span>{formattedDate}</span>
    }

    return content
}

const columns = ({
    handleDeleteApiKey,
    handleEditApiKey,
}: {
    handleDeleteApiKey: (id: string) => void
    handleEditApiKey: (data: any) => void
}) => {
    return [
        {
            Header: 'Name',
            accessor: 'name',
            minWidth: 100,
            width: 150,
        },
        {
            Header: 'Token',
            accessor: 'token',
            minWidth: 300,
            width: 350,
        },
        {
            Header: 'Description',
            accessor: 'description',
            minWidth: 250,
            width: 300,
        },
        {
            Header: 'Created On',
            accessor: 'created_on',
            minWidth: 100,
            width: 140,
            // eslint-disable-next-line new-cap
            Cell: (props: { row: { original: any } }) => (
                <DateRenderer value={props?.row?.original?.created_on} />
            ),
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            minWidth: 100,
            width: 130,

            Cell: (props: { row: { original: any } }) => {
                const { original: data } = props.row

                return (
                    <StyledActionWrapper>
                        <IconButton
                            onClick={() => handleDeleteApiKey(data.id)}
                            icon={() => <StyledDeleteIcon />}
                            size={IconButton.sizes?.SMALL}
                            kind={IconButton.kinds?.TERTIARY}
                            ariaLabel='Delete'
                        />

                        <IconButton
                            onClick={() => handleEditApiKey(data)}
                            icon={() => <StyledEditIcon />}
                            size={IconButton.sizes?.SMALL}
                            kind={IconButton.kinds?.TERTIARY}
                            ariaLabel='Edit'
                        />
                    </StyledActionWrapper>
                )
            },
        },
    ]
}

export default columns

export const StyledActionWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -6px;
`
